import {gsap} from "../LibrariesImport";

export default class BlockSliderMultipleText {
	constructor() {
		this.blocks = document.querySelectorAll(".block-slider-multiple-text");

		if (!this.blocks) {
			return;
		}

		this.buildSliders();
	}

	buildSliders() {
		this.blocks.forEach(block => {
			const sliderText = block.querySelector(".swiper-text");
			const sliderImage = block.querySelector(".swiper-image");
			const swiperPagination = block.querySelector(".swiper-custom-pagination-fraction");
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			// const drag = slider.querySelector(".swiper-scrollbar");
			// const arrows = slider.querySelector(".arrows");
			// const canvas = slider.querySelector("canvas");
			const fmt = n => n < 10 ? '0' + n : n;

			this.swiperText = new Swiper(sliderText, {
				loop: false,
				grabCursor: true,
				slidesPerView: 1,
				speed: 500,
				effect: 'creative',
				creativeEffect: {
					prev: {
						translate: [-100, 0, -100],
						opacity: 0
					},
					next: {
						translate: [100, 0, 100],
						opacity: 0
					},
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});

			const updatePagination = () => {
				swiperPagination.innerHTML = `<span class="swiper-pagination-current">${fmt(this.swiperText.realIndex + 1)}</span> / <span>${fmt(this.swiperText.slides.length)}</span>`;
			};

			updatePagination();
			this.swiperText.on('slideChange', updatePagination);

			this.swiperImage = new Swiper(sliderImage, {
				slidesPerView: "1",
				grabCursor: false,
				allowTouchMove: false,
				speed: 800,
				effect: 'creative',
				creativeEffect: {
					prev: {
						// will set `translateZ(-400px)` on previous slides
						translate: [-50, 0, -10],
						opacity: 0
					},
					next: {
						// will set `translateX(100%)` on next slides
						translate: [100, 0, 10],
						opacity: 0
					},
				}
			});

			this.controller();

		});
	}

	controller(){

		const checkBreakpoint = (mql) => {
			if (mql.matches) {
				this.swiperText.controller.control = this.swiperImage;
			} else {
				this.swiperText.controller.control = null;
			}
		};

		// Créer l'écouteur de média
		const mql = window.matchMedia('(min-width: 992px)');

		// Exécuter au chargement
		checkBreakpoint(mql);

		// Ecouter les redimensionnements
		mql.addEventListener('change', checkBreakpoint);

	}

}
